import React from 'react';

function FourOhFour() {
  return <p>404</p>;
}

export default FourOhFour;
